<template>
  <div class="sync-pill" :class="{
    online,
    offline: !online,
    active: syncing,
    compact,
  }" :title="label">
    <span class="dot"></span>
    <span v-if="!compact">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'SyncStatusPill',
  props: {
    online: { type: Boolean, default: true },
    syncing: { type: Boolean, default: false },
    socketConnected: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  computed: {
    label() {
      if (!this.online) return 'Sin conexión';
      if (this.syncing) return 'Sincronizando';
      if (this.socketConnected) return 'Tiempo real activo';
      return 'En línea';
    },
  },
};
</script>

<style scoped>
.sync-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.24);
  padding: 8px 12px;
  font-size: 13px;
  color: #475569;
}
.sync-pill.compact {
  padding: 0;
  width: 16px;
  height: 16px;
  justify-content: center;
  background: transparent;
  border: none;
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #f59e0b;
}
.sync-pill.online .dot {
  background: #22c55e;
}
.sync-pill.offline .dot {
  background: #ef4444;
}
.sync-pill.active .dot {
  animation: pulse 1s infinite;
}
@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.35); opacity: 0.6; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
